// extracted by mini-css-extract-plugin
export default {"label":"HeaderItem_label__WyQgb","right":"HeaderItem_right__mvfZ1"};